import { FileDown } from "lucide-react";

export const BROCHURE_URL = "/vata-infrastructures-company-profile.pdf";

export const BrochureButton = ({ className = "", dark = false, testid = "brochure-download-button", label = "Download company profile (PDF)" }) => (
  <a
    href={BROCHURE_URL}
    download
    data-testid={testid}
    className={`inline-flex items-center gap-2 border text-sm font-semibold uppercase tracking-wider transition-[background-color,color,border-color] ${dark ? "border-[var(--ink)] px-5 py-3 text-[var(--ink)] hover:bg-[var(--ink)] hover:text-white" : "border-white/40 px-5 py-3 text-white hover:border-white hover:bg-white/10"} ${className}`}
  >
    <FileDown className="h-4 w-4" /> {label}
  </a>
);
